import { ArrowUpDown, ArrowUp, ArrowDown } from "lucide-react";
import type {
  AttributeSortDirection,
  AttributeSortField,
} from "./attributeUtils";

interface AttributesTableHeaderProps {
  sortField: AttributeSortField;
  sortDirection: AttributeSortDirection;
  onSort: (field: AttributeSortField) => void;
}

function SortIcon({
  field,
  currentField,
  direction,
}: {
  field: AttributeSortField;
  currentField: AttributeSortField;
  direction: AttributeSortDirection;
}) {
  if (currentField !== field) {
    return <ArrowUpDown className="ml-1 h-4 w-4 text-ink-400" />;
  }
  return direction === "asc" ? (
    <ArrowUp className="ml-1 h-4 w-4 text-ink-600" />
  ) : (
    <ArrowDown className="ml-1 h-4 w-4 text-ink-600" />
  );
}

export function AttributesTableHeader({
  sortField,
  sortDirection,
  onSort,
}: AttributesTableHeaderProps) {
  return (
    <thead>
      <tr className="border-b border-grid-200 bg-grid-50">
        <th className="px-6 py-4 text-left">
          <button
            onClick={() => onSort("name")}
            className="flex items-center text-xs font-semibold uppercase tracking-wider text-ink-600 hover:text-ink-900"
          >
            Attribute Name
            <SortIcon
              field="name"
              currentField={sortField}
              direction={sortDirection}
            />
          </button>
        </th>
        <th className="px-6 py-4 text-left">
          <button
            onClick={() => onSort("categoriesLinked")}
            className="flex items-center text-xs font-semibold uppercase tracking-wider text-ink-600 hover:text-ink-900"
          >
            Categories linked
            <SortIcon
              field="categoriesLinked"
              currentField={sortField}
              direction={sortDirection}
            />
          </button>
        </th>
        <th className="px-6 py-4 text-left">
          <button
            onClick={() => onSort("valuesLinked")}
            className="flex items-center text-xs font-semibold uppercase tracking-wider text-ink-600 hover:text-ink-900"
          >
            Values linked
            <SortIcon
              field="valuesLinked"
              currentField={sortField}
              direction={sortDirection}
            />
          </button>
        </th>
        <th className="px-6 py-4 text-right text-xs font-semibold uppercase tracking-wider text-ink-600">
          Actions
        </th>
      </tr>
    </thead>
  );
}
